
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"16","height":"16","viewBox":"0 0 16 16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"clip-path":"url(#clip0_16554_22610)"}},[_c('path',{attrs:{"d":"M4 .5V2h6V.5c0-.25.219-.5.5-.5.25 0 .5.25.5.5V2h1c1.094 0 2 .906 2 2v2H1v8c0 .563.438 1 1 1h4.063l-.032.156c-.062.281-.062.594.032.844H2c-1.125 0-2-.875-2-2V4c0-1.094.875-2 2-2h1V.5c0-.25.219-.5.5-.5.25 0 .5.25.5.5zM2 3c-.563 0-1 .469-1 1v1h12V4c0-.531-.469-1-1-1H2zm1.5 8h2c.25 0 .5.25.5.5 0 .281-.25.5-.5.5h-2a.494.494 0 01-.5-.5c0-.25.219-.5.5-.5zM3 8.5c0-.25.219-.5.5-.5h5c.25 0 .5.25.5.5 0 .281-.25.5-.5.5h-5a.494.494 0 01-.5-.5zm11.188-.25a.49.49 0 00-.688 0l-.781.781 1.25 1.25.781-.781a.49.49 0 000-.688l-.563-.562zm-5.5 4.813c-.063.062-.094.156-.126.25l-.374 1.53 1.53-.405c.063 0 .157-.063.22-.126L13.25 11 12 9.75l-3.313 3.313zm4.093-5.5a1.49 1.49 0 012.125 0l.531.53a1.49 1.49 0 010 2.126l-4.78 4.812a1.591 1.591 0 01-.72.375L7.595 16c-.157.063-.344 0-.469-.125A.523.523 0 017 15.406l.594-2.344c.062-.28.187-.5.375-.687l4.812-4.813z","fill":"#000"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"clip0_16554_22610"}},[_c('path',{attrs:{"fill":"#fff","d":"M0 0h16v16H0z"}})])])])
          )
        }
      }
    